define([
    "jquery",
    "underscore",
    "marionette",
    "views/profile/upload_documents_view",
    "forms/profile/cc_form"
], function($, _, Marionette, UploadDocumentsView, CcForm) {
    return UploadDocumentsView.extend({
        ui: {
            'ccFrontFile': '#cc_front_file',
            'ccFrontName': '#cc_front_name',
            'ccFrontPreview': '#cc_front_preview',
            'ccFrontCollapse': '#cc_front_collapse',
            'ccFront': '#cc_front',
            'ccBackFile': '#cc_back_file',
            'ccBackName': '#cc_back_name',
            'ccBackPreview': '#cc_back_preview',
            'ccBackCollapse': '#cc_back_collapse',
            'ccBack': '#cc_back',
            'ccSubmit': '#submit_cc',
            'ccForm': '#cc_form'
        },

        events:{
            'click @ui.ccSubmit': function(e){
                if(e) e.preventDefault();
                this.submit('cc');
            }
        },

        initialize: function(){
            this.bindUIElements();
            this.delegateEvents();

            UploadDocumentsView.prototype.initialize.apply(this);

            this.ccForm = new CcForm();

            this.initFileUpload(this.ui.ccFrontFile, 'ccFront');
            this.initFileUpload(this.ui.ccBackFile, 'ccBack');
        }
    });
});
